import { defineComponent as _defineComponent } from 'vue'
import CustomSelector from '@/components/custom_selector/CustomSelector.vue';
import { StatesEnum } from '@/models/state_enum';
import { StateUtils } from '@/utils/state_utils';
import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'StateSelector',
  props: {
    stateError: { type: String, required: false }
  },
  emits: ["change"],
  setup(__props: any, { expose: __expose }) {

const stateSelector = ref<InstanceType<typeof CustomSelector>>();
const state = ref<StatesEnum | null>(null);
const initialSelection = ref<number | undefined>(undefined)

 



__expose({
  setSelected(stateCode: string) {
    const name = StateUtils.formatNameForSearch(stateCode);
    initialSelection.value = StateUtils.getStateIndex(name)
    const validate = initialSelection?.value ?? -1
    if (validate  < 0) stateSelector.value?.clearSelection();
    else stateSelector.value?.setSelected(initialSelection.value ?? null);
  },
  clearSelection() {
    stateSelector.value?.clearSelection();
    initialSelection.value = undefined;
  }
});


const __returned__ = { stateSelector, state, initialSelection, CustomSelector, get StatesEnum() { return StatesEnum } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})